<template>
  <div class="cookie-consent-wrapper">
    <transition name="slide-up">
      <div v-if="showBanner" class="cookie-consent-banner">
        <button 
          class="cookie-close-btn"
          aria-label="סגור"
          type="button" 
          @click="closeBanner">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="cookie-consent-container">
          <div class="cookie-consent-content">
            <p class="cookie-message">
              {{ $t('cookieConsent.message') }}
              <a href="#" class="cookie-link" @click.prevent="openPrivacyPolicyModal">
                {{ $t('cookieConsent.policyLink') }}
              </a>
            </p>
          </div>
        </div>
      </div>
    </transition>

    <b-modal
      id="privacy-policy-modal"
      ref="privacyPolicyModal"
      centered
      size="lg"
      hide-footer>
      <div v-html="linkHtml"></div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { BModal } from 'bootstrap-vue';
const {VUE_APP_PACK_DOMAIN} = process.env;

export default {
  name: 'App',
  components: { BModal },
  computed: {
    ...mapState({
      showBanner: state => state.cookieConsent.showBanner,
    }),
    linkHtml() {
      return `<iframe src="${VUE_APP_PACK_DOMAIN}/${this.privacyPolicyUrl}" title="Privacy Policy" style="width:100%;height:70vh;border:0;" loading="lazy"></iframe>`;
    }
  },
  data(){
    return {
      privacyPolicyUrl: '/מדיניות_פרטיות?no-header&no-footer&no-cookie-bar',
    }
  },
  methods: {
    closeBanner() {
      this.$store.dispatch('dismissCookieBanner');
    },
    openPrivacyPolicyModal() {
      if (this.$refs.privacyPolicyModal) {
        this.$refs.privacyPolicyModal.show();
      }
    },
  },
}
</script>


<style scoped>
.cookie-consent-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-top: 3px solid #005ca3;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  padding: 1.5rem;
  animation: slideUp 0.4s ease-out;
}

.cookie-close-btn {
  position: absolute;
  left: 1rem;
  top: 1rem;
  background: transparent;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  z-index: 1;
}

.cookie-close-btn:hover {
  background: rgba(0, 92, 163, 0.1);
  color: #005ca3;
  transform: scale(1.1);
}

.cookie-close-btn:active {
  transform: scale(0.95);
}

.cookie-consent-container {
  max-width: 1250px;
  margin: 0 auto;
  display: flex;
  gap: 2rem;
  align-items: center;
  flex-wrap: wrap;
}

.cookie-consent-content {
  flex: 1;
  min-width: 300px;
}

.cookie-message {
  margin: 0;
  color: #666;
  font-size: 0.95rem;
  line-height: 1.5;
}

.cookie-link {
  color: #005ca3;
  text-decoration: underline;
  font-weight: 500;
  cursor: pointer;
}

.cookie-link:hover {
  color: #004080;
}

/* Animations */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.4s ease-out, opacity 0.4s ease-out;
}

.slide-up-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Responsive */
@media (max-width: 768px) {
  .cookie-consent-banner {
    padding: 1rem;
    padding-left: 3rem;
  }

  .cookie-consent-container {
    flex-direction: column;
    gap: 1rem;
  }

  .cookie-consent-content {
    min-width: 100%;
  }

  .cookie-message {
    font-size: 0.9rem;
  }

  .cookie-close-btn {
    left: 0.5rem;
    top: 0.5rem;
  }
}
</style>